import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SamwinSkillTypeEnum } from 'src/app/store/samwin/samwin-skills/samwin-skills-type-enum';
import { SamwinSkillsState } from 'src/app/store/samwin/samwin-skills/samwin-skills.state';
import { SkillConstants } from 'src/app/store/samwin/samwin-skills/skill-constants';
import { SkillGroup } from 'src/app/store/samwin/samwin-skills/skill-group';

@Component({
   selector: 'samweb-skill-active-state-checkbox',
   templateUrl: './skill-active-state-checkbox.component.html',
   styleUrls: ['./skill-active-state-checkbox.component.scss'],
})
export class SkillActiveStateCheckboxComponent implements OnInit {
   @Input()
   public brickInstanceId: string;

   @Input()
   public userId: number;

   @Input()
   public disabled = false;

   @Input()
   public skillGroup: SkillGroup;

   public isSkillLoading$: Observable<boolean>;

   @Output()
   public activeStateChanged = new EventEmitter();

   @Input()
   public disableLoadingAnimation = false;

   constructor(private store: Store) {}

   ngOnInit(): void {
      if (this.skillGroup.skillId === SkillConstants.OVERALL_SKILL_ID) {
         this.isSkillLoading$ = this.store
            .select(SamwinSkillsState.isAllSkillLoading)
            .pipe(
               map((isLoading) => isLoading(SamwinSkillTypeEnum.valueOf(this.skillGroup?.skillConfiguration?.skillType ?? SamwinSkillTypeEnum.CALLING.value)))
            );
      } else {
         this.isSkillLoading$ = this.store.select(SamwinSkillsState.isSkillLoading).pipe(map((isLoading) => isLoading(this.skillGroup?.skillId)));
      }
   }

   changeSkillStatus($event) {
      $event.preventDefault();
      return this.activeStateChanged.emit($event);
   }
}
